//#region ../../node_modules/@jwplayer/fe-common/module/cookies/index.js
function isDefined(v) {
	return !(typeof v === "undefined");
}
function formatCookie(key, value, config) {
	if (key.trim() === "") throw new Error("Key may not be empty");
	return [`${key}=${value}`, ...Object.entries(config ?? {}).map(([configKey, configValue]) => {
		if (typeof configValue === "undefined") return;
		if (configValue === true) return configKey;
		if (configValue instanceof Date) configValue = configValue.toUTCString();
		return `${configKey}=${configValue}`;
	})].filter(isDefined).join("; ");
}
var documentCookie = /* @__PURE__ */ (() => {
	let mockCookie = "";
	return {
		set(value) {
			if (typeof document === "undefined" || typeof document.cookie === "undefined") mockCookie = value;
			else document.cookie = value;
		},
		get() {
			if (typeof document === "undefined" || typeof document.cookie === "undefined") return mockCookie;
			return document.cookie;
		}
	};
})();
function setCookie(key, value, config) {
	const cookieString = formatCookie(key, value, config);
	documentCookie.set(cookieString);
}
function deleteCookie(key, config) {
	documentCookie.set(formatCookie(key, "", {
		...config,
		"Max-Age": -999999
	}));
}
function getCookie(key) {
	const cookies = documentCookie.get().split(";").map((i) => i.trim());
	for (const cookie of cookies) {
		const parts = cookie.split("=");
		if (parts.length < 2) continue;
		const name = parts.shift();
		if (name === key) return parts.join("=");
	}
	return void 0;
}
function createCookieManager(config) {
	let _config = config;
	return {
		setConfig(config2) {
			_config = config2;
		},
		getCookie,
		setCookie: (key, value, config2) => {
			setCookie(key, value, {
				...config2,
				..._config
			});
		},
		deleteCookie: (key, config2) => {
			deleteCookie(key, {
				...config2,
				..._config
			});
		}
	};
}

//#endregion
export { createCookieManager };
//# sourceMappingURL=index.js.map